import './app.scss';

import './components/header';
import './components/hero';
import './components/gallery';
import './components/language-switch';
import './components/tabs';
